module.exports = __webpack_public_path__ + "static/img/logo_header.0ed190ad.svg";